
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 241.35 107.22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#1b61dd","d":"M72.25 107.22a51 51 0 11101.95 0M149.59 26.37A26.36 26.36 0 11123.22 0a26.36 26.36 0 0126.37 26.37"}}),_c('path',{attrs:{"fill":"#fdd462","d":"M240.19 14.27c-6.29 1.37-8.81 3.89-10.18 10.18a1.48 1.48 0 01-2.89 0c-1.37-6.29-3.89-8.81-10.18-10.18a1.48 1.48 0 010-2.89c6.29-1.37 8.81-3.89 10.18-10.18a1.48 1.48 0 012.89 0c1.37 6.29 3.89 8.81 10.18 10.18a1.48 1.48 0 010 2.89M217.33 44.08c-3.28.71-4.6 2-5.31 5.31a.77.77 0 01-1.5 0c-.72-3.28-2-4.6-5.31-5.31a.77.77 0 010-1.5c3.28-.71 4.59-2 5.31-5.31a.77.77 0 011.5 0c.71 3.28 2 4.6 5.31 5.31a.77.77 0 010 1.5M24.41 14.95c-6.29 1.37-8.81 3.89-10.18 10.18a1.48 1.48 0 01-2.89 0c-1.37-6.29-3.89-8.81-10.17-10.18a1.48 1.48 0 010-2.89c6.29-1.37 8.81-3.89 10.16-10.18a1.48 1.48 0 012.89 0c1.37 6.29 3.89 8.81 10.18 10.18a1.48 1.48 0 010 2.89M35.92 41c-3.28.71-4.6 2-5.31 5.31a.77.77 0 01-1.51 0c-.71-3.28-2-4.6-5.31-5.31a.77.77 0 010-1.51c3.28-.71 4.59-2 5.31-5.31a.77.77 0 011.51 0c.71 3.28 2 4.6 5.31 5.31a.77.77 0 010 1.51"}})])
          )
        }
      }
    